




































































































import Vue, { PropType } from "vue";
import graphqlQuery from "@/service/Api";
import { getInitialsName } from "@/helpers";
const basePhotoUrl = process.env.VUE_APP_BASE_PHOTO_URL;
type DifferenceStatus = "INCREASE" | "DECREASE" | "NETRAL";
export default Vue.extend({
  props: {
    isLoading: {
      type: Object,
      default: () => {
        return { kritikSaran: false, visitCount: false };
      },
    },
    isError: {
      type: Object,
      default: () => {
        return { kritikSaran: false, visitCount: false };
      },
    },
    visitCount: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    kritikSaranCount: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    ratingCount: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  components: {
    IconStar: () => import("@/assets/static/dashboard-page/star.svg"),
    IconUserVisit: () =>
      import("@/assets/static/dashboard-page/user-visit.svg"),
    IconKritikSaran: () =>
      import("@/assets/static/dashboard-page/kritik-saran.svg"),
    DashboardHeaderCard: () => import("./DashboardHeaderCard.vue"),
  },

  data() {
    return {
      isLoadingBestFrontDesk: true,
      isErrorBestFrontDesk: false,
      basePhotoUrl: basePhotoUrl,
      bestFrontDeskScores: {
        count: 0,
        user: {
          fullname: "",
          email: "",
          photo: "",
          unit: {
            name: "",
          },
        },
      },
      isPhotoError: false,
    };
  },
  computed: {
    kritikSaranCountCalculate() {
      let today: number | string = "";
      let difference = 0;
      let differenceStatus: DifferenceStatus = "NETRAL";

      const isYesterdayEmpty = this.kritikSaranCount.length === 1;
      const isEmpty = this.kritikSaranCount.length === 0;

      if (!isEmpty) {
        if (isYesterdayEmpty) {
          today = this.kritikSaranCount[0];
          difference = today;
          differenceStatus = "INCREASE";
        } else {
          today = this.kritikSaranCount[1];
          difference = this.kritikSaranCount[1] - this.kritikSaranCount[0];
          if (difference < 0) {
            differenceStatus = "DECREASE";
            difference = -difference;
          } else if (difference === 0) {
            differenceStatus = "NETRAL";
          } else {
            differenceStatus = "INCREASE";
          }
        }
      } else {
        today = "Hari ini belum ada penilaian.";
      }
      return {
        today: today,
        isEmpty: isEmpty,
        difference: difference,
        differenceStatus: differenceStatus,
      };
    },
  },
  methods: {
    graphqlQuery,
    getInitialsName,
    async getBestFrontDeskScores() {
      this.isLoadingBestFrontDesk = true;
      const query = `
        query {
          getBestFrontDeskScores {
            count
            user {
              fullname
              email
              photo
              unit {
                name
              }
            }
            surveyQuestion
          }
        }
      `;

      await this.graphqlQuery({ query })
        .then((res) => {
          this.bestFrontDeskScores = res.data.getBestFrontDeskScores;
          this.isErrorBestFrontDesk = false;
        })
        .catch(() => (this.isErrorBestFrontDesk = true));
      this.isLoadingBestFrontDesk = false;
    },
  },
  mounted() {
    this.getBestFrontDeskScores();
  },
});
